import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Header from '../../../components/Header/Header';

// Import Style
import '../style.scss';

class GenericMessagePage extends Component {
  getMessage() {
    switch (this.props.route.path) {
      case 'no-dashboards': {
        return (
          <h1>No dashboards available</h1>
        );
      }      
      case 'no-create-dashboard-permissions': {
        const { router } = this.props;
        const noDashboard = router && router.location && router.location.query &&
          router.location.query['no-dashboard'] == 'true';
        return (
          <React.Fragment>
            <h1>No dashboards available</h1>
            {noDashboard ?
              <React.Fragment>
                <p>
                  You don't have access to the boards associated with this dashboard.
                </p>
                <p>
                  To request access, please click the button below.
                </p>
                <a href='#' className='btn btn-primary'>Request Permissions</a>
              </React.Fragment>
              :
              <React.Fragment>
                <p>
                  It looks like you don't have the necessary permissions to create new dashboards right now.
                </p>
                <p>
                  To request access, please click the button below.
                </p>
                <a href='#' className='btn btn-primary'>Request Permissions</a>
              </React.Fragment>
              
            }
          </React.Fragment>
        );
      }
      case 'expired': {
        return (
          <React.Fragment>
            <h1>Your free trial has expired</h1>
            <p>
              Your free trial has come to an end, and access to the analytics suite is no longer available.
            </p>
            <p>
              To continue using the platform, please upgrade your account using the button below. If you have any questions, feel free to contact us directly at <a href="mailto:hello@getnave.com" >hello@getnave.com</a>.
            </p>
            <a href='/subscribe' className='btn btn-primary'>Upgrade Now</a>
          </React.Fragment>
        );
      }
      case 'unlicensed': 
      case 'cancelled': {
        const { user } = this.props;
        const email = !user.hasOwnAccount && !!user.managedBy ? user.managedBy : user.email;
        const mailToLink = `mailto:${email}`;

        return (
          <React.Fragment>
            <h1>Access Unavailable</h1>
            <p>
              It looks like your access to the analytics suite is currently inactive. This may be due to a canceled subscription or because no active license is associated with your account.
            </p>
            <p>
              To regain access or resolve this issue, please contact your account owner at <strong>{email}</strong> for further assistance.
            </p>
            
          </React.Fragment>
        );
      }
      case 'no-streams': {
        return (
          <React.Fragment>
            <h1>Create your first value stream</h1>
            <p>
              Select the team dashboards you’d like to include to build a value stream and visualize your end to end delivery flow.
            </p>            
            <a href='/configure' className='btn btn-primary'>Create value stream</a>
          </React.Fragment>
        );
      }
      case 'no-value-stream-permissions':{
        return (
          <React.Fragment>
            <h1>No value streams available</h1>
              <React.Fragment>
                <p>
                  It looks like you don't have the necessary permissions to view this value stream right now.
                </p>
               
                <a href='/report' className='btn btn-primary'>View own Value streams</a>
              </React.Fragment>              
          </React.Fragment>
        );
      }
      case 'no-portfolios': {
        return (
          <React.Fragment>
            <h1>Create your first portfolio</h1>
            <p>
              Select the value streams you want to include to build a portfolio and track performance across your organization.
            </p>            
            <a href='/portfolio' className='btn btn-primary'>Create portfolio</a>
          </React.Fragment>
        );
      }
      case 'no-enough-streams': {
        return (
          <React.Fragment>
            <h1>You’ll need at least two value streams to build a portfolio</h1>
            <p>
              Please create a new value stream before proceeding.
            </p>            
            <a href='/configure?fromPortfolio=true' className='btn btn-primary'>Create value stream</a>
          </React.Fragment>
        );
      }
    }
  }
  getImage() {
    switch (this.props.route.path) {     
      case 'no-streams': {
        return ' streams';
      }
      case 'no-portfolios': {
        return ' portfolios';
      }
      case 'no-enough-streams': {
        return ' no-enough-streams';
      }
    }
  }

  render() {
    const classImg = 'no-dashboard-dog' + this.getImage();
    return (
      <div>
        <Header showHome={this.props.route.path === 'unlicensed' ? false : true} />
        <div className='no-dashboard'>
          <div className='no-dashboard-content'>
            {this.getMessage()}
          </div>
          <div className={classImg}>

          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

export default withRouter(connect(mapStateToProps)(GenericMessagePage));
